import { z } from 'zod';

export const formSchema = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  email: z.string().email('Invalid email address'),
  company: z.string().min(1, 'Company name is required'),
  businessDescription: z.string().min(1, 'Business description is required'),
  problem: z.string().min(1, 'Problem description is required'),
  solution: z.string().min(1, 'Solution is required'),
  platforms: z.string().min(1, 'Platforms are required'),
  projectDuration: z.string().min(1, 'Project duration is required'),
  budget: z.string().min(1, 'Budget is required'),
  additionalCosts: z.string().optional(),
  callOutcome: z.string().min(1, 'Call outcome is required'),
});

export type FormData = z.infer<typeof formSchema>;